function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import includes from 'lodash/includes';
import unset from 'lodash/unset';
import map from 'lodash/map';
import cn from 'classnames';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import { createValidatorRules } from 'helpers/templatedFields';
import templateFieldShape from 'shapes/templateFieldShape';
import DateOfBirthFormPartial from 'components/DateOfBirthFormPartial';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import InputLikeCheckboxRadioGroup from 'components/Form/InputLikeCheckboxRadioGroup';
import InputLikeCheckboxRadio from 'components/Form/InputLikeCheckboxRadio';
import TextArea from 'components/Form/TextArea';
import Select from 'components/Form/Select';
var _React_PureComponent;
class TemplatedFields extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        this.onSetSelects();
        this.onAddValidatorRules();
    }
    componentDidUpdate(prevProps) {
        if (this.props.template && !isEqual(prevProps.template, this.props.template) || this.props.formValues && !isEqual(get(prevProps.formValues, 'values'), get(this.props.formValues, 'values'))) {
            this.onSetSelects();
            this.onAddValidatorRules();
        }
    }
    onAddValidatorRules() {
        let validatorRules = {};
        forEach(this.props.template, (fieldTemplate)=>{
            validatorRules = _object_spread({}, validatorRules, createValidatorRules(fieldTemplate));
        });
        this.props.onAddValidatorRules(validatorRules);
    }
    onSetGroupInstructions(activeOption, options, slaveFieldTemplate, groupTemplate) {
        const { isOneLiner } = this.props;
        let instructions;
        if (activeOption && activeOption.instructionsKey) {
            instructions = get(this.props.localizationResources, [
                activeOption.instructionsKey,
                'value'
            ]);
            if (isOneLiner || options.length === 1) {
                slaveFieldTemplate.infoMessage = instructions;
            } else {
                groupTemplate.infoMessage = instructions;
            }
        }
        if (!instructions) {
            if (groupTemplate.instructionsKey) {
                unset(groupTemplate, 'instructionsKey');
            } else if (slaveFieldTemplate.instructionsKey) {
                unset(slaveFieldTemplate, 'instructionsKey');
            }
        }
    }
    onSetSlaveValidator(value, fieldTemplate, groupTemplate) {
        const { masterFor, options } = fieldTemplate;
        if (isArray(options)) {
            const activeOption = find(options, {
                value
            }) || {};
            const slaveFieldTemplate = find(groupTemplate.fields, {
                name: masterFor
            });
            this.onSetGroupInstructions(activeOption, options, slaveFieldTemplate, groupTemplate);
            const { slaveRegExp } = activeOption;
            if (slaveRegExp) {
                slaveFieldTemplate.regExp = slaveRegExp;
                const validatorRules = createValidatorRules(slaveFieldTemplate, groupTemplate);
                this.props.onAddValidatorRules(validatorRules);
            }
        }
    }
    onSetMasterValue(input, fieldTemplate, groupTemplate) {
        const { value } = input;
        this.onSetSlaveValidator(value, fieldTemplate, groupTemplate);
        this.onSetValue(input);
    }
    onSetValue(input) {
        this.props.onSetFormValue(input);
    }
    onSetSelects(groupTemplate = null, values = {}) {
        const { formValues } = this.props;
        const fieldTemplates = groupTemplate ? groupTemplate.fields : this.props.template;
        forEach(fieldTemplates, (fieldTemplate)=>{
            const name = groupTemplate ? `${groupTemplate.name}.${fieldTemplate.name}` : fieldTemplate.name;
            if (isArray(fieldTemplate.options) && fieldTemplate.options.length === 1) {
                const { value } = fieldTemplate.options[0];
                values[name] = value;
                if (fieldTemplate.masterFor) {
                    this.onSetSlaveValidator(value, fieldTemplate, groupTemplate);
                }
            } else if (fieldTemplate.masterFor) {
                const value = get(formValues, [
                    'values',
                    name
                ]);
                if (value) {
                    this.onSetSlaveValidator(value, fieldTemplate, groupTemplate);
                }
            } else if (fieldTemplate.type === 'group' && isArray(fieldTemplate.fields) && fieldTemplate.fields.length) {
                this.onSetSelects(fieldTemplate, values);
            }
        });
        if (!groupTemplate) {
            this.props.onSetFormValues(values);
        }
    }
    getLabelMessage(labelMessage, name) {
        return labelMessage ? get(this.props.localizationResources, [
            labelMessage,
            'value'
        ], labelMessage) : get(this.props.messages.labels, name, name);
    }
    getIsFieldDisabled(fieldName) {
        return includes(this.props.disabledFields, fieldName);
    }
    renderTextArea(fieldTemplate) {
        const attributes = fieldTemplate.maxLength ? {
            maxLength: fieldTemplate.maxLength
        } : {};
        const labelMessage = this.getLabelMessage(fieldTemplate.labelMessage, fieldTemplate.name);
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: fieldTemplate.name,
            labelMessage: labelMessage,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(TextArea, {
                placeholder: this.props.messages.placeholders[fieldTemplate.name] || null,
                onChange: this.props.onSetFormValue,
                attributes: attributes
            })
        }, fieldTemplate.name);
    }
    renderGender(fieldTemplate) {
        const isDisabled = this.getIsFieldDisabled('gender');
        const options = fieldTemplate.options.map((option)=>/*#__PURE__*/ _jsx(InputLikeCheckboxRadio, {
                labelMessage: this.getLabelMessage(option.labelKey, option.name),
                inputValue: option.value,
                containerClassName: "col-6",
                isRadio: true,
                onChange: (input)=>this.onSetValue(input),
                isDisabled: isDisabled
            }, option.value));
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: fieldTemplate.name,
            labelMessage: this.getLabelMessage(fieldTemplate.labelMessage, fieldTemplate.name),
            formValues: this.props.formValues,
            isOneLiner: this.props.isOneLiner,
            children: /*#__PURE__*/ _jsx(InputLikeCheckboxRadioGroup, {
                className: "row-gap-6",
                children: options
            })
        }, fieldTemplate.name);
    }
    renderControl(fieldTemplate, groupTemplate = null) {
        const placeholderMessage = get(this.props.messages.placeholders, fieldTemplate.name);
        if (fieldTemplate.options) {
            const options = map(fieldTemplate.options, (option)=>{
                const label = get(this.props.localizationResources, [
                    option.labelKey,
                    'value'
                ], option.labelKey);
                return {
                    value: option.value,
                    label
                };
            });
            return /*#__PURE__*/ _jsx(Select, {
                optionsFrom: options,
                valueKey: "value",
                labelKey: "label",
                isDisabled: fieldTemplate.options.length === 1 || this.getIsFieldDisabled(fieldTemplate.name),
                onChange: (input)=>fieldTemplate.masterFor ? this.onSetMasterValue(input, fieldTemplate, groupTemplate) : this.onSetValue(input)
            });
        }
        return /*#__PURE__*/ _jsx(Input, {
            placeholder: placeholderMessage,
            onChange: (input)=>this.onSetValue(input),
            isDisabled: this.getIsFieldDisabled(fieldTemplate.name)
        });
    }
    renderGroupInstructions(fieldTemplate) {
        if (!fieldTemplate.infoMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "form-info px-5 mb-6",
            children: fieldTemplate.infoMessage
        });
    }
    renderGroup(fieldTemplate) {
        if (!isArray(fieldTemplate.fields) || !fieldTemplate.fields.length) {
            return null;
        }
        const masterFields = filter(fieldTemplate.fields, (f)=>f.masterFor);
        let hiddenFields = 0;
        forEach(masterFields, (mf)=>{
            if (isArray(mf.options) && mf.options.length === 1) {
                mf.isHidden = true;
                hiddenFields++;
                const option = mf.options[0];
                const slaveFieldTemplate = find(fieldTemplate.fields, {
                    name: mf.masterFor
                });
                slaveFieldTemplate.labelMessage = get(this.props.localizationResources, [
                    option.labelKey,
                    'value'
                ], option.labelKey);
            }
        });
        const col = this.props.isOneLiner ? 12 : Math.round(12 / (fieldTemplate.fields.length - hiddenFields));
        const withInstructionClassName = fieldTemplate.infoMessage ? 'mb-0' : null;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('form-control-group row', {
                'form-control-group--one-liner': this.props.isOneLiner
            }),
            children: [
                map(fieldTemplate.fields, (ft)=>{
                    if (ft.isHidden) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsx("div", {
                        className: `col-${col}`,
                        children: this.renderField(ft, fieldTemplate, withInstructionClassName)
                    }, ft.name);
                }),
                this.renderGroupInstructions(fieldTemplate)
            ]
        }, fieldTemplate.name);
    }
    renderField(fieldTemplate, groupTemplate = null, className = null) {
        if (fieldTemplate.name === 'avatar') return null;
        if (fieldTemplate.name === 'gender') {
            return this.renderGender(fieldTemplate);
        }
        if (fieldTemplate.type === 'date') {
            return /*#__PURE__*/ _jsx(DateOfBirthFormPartial, {
                formValues: this.props.formValues,
                errorsMessages: this.props.messages.validatorRules,
                onSetFormValue: (input)=>this.onSetValue(input),
                isDisabled: this.getIsFieldDisabled(fieldTemplate.name),
                isOneLiner: this.props.isOneLiner
            }, fieldTemplate.name);
        }
        if (fieldTemplate.type === 'textArea') {
            return this.renderTextArea(fieldTemplate);
        }
        if (fieldTemplate.type === 'group') {
            return this.renderGroup(fieldTemplate);
        }
        const labelMessage = this.getLabelMessage(fieldTemplate.labelMessage, fieldTemplate.name);
        const infoMessage = this.getLabelMessage(fieldTemplate.infoMessage, null);
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: groupTemplate ? `${groupTemplate.name}.${fieldTemplate.name}` : fieldTemplate.name,
            labelMessage: labelMessage,
            infoMessage: infoMessage,
            validatorRules: this.validatorRules,
            className: className,
            formValues: this.props.formValues,
            isOneLiner: this.props.isOneLiner,
            children: this.renderControl(fieldTemplate, groupTemplate)
        }, fieldTemplate.name);
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            children: map(this.props.template, (fieldTemplate)=>this.renderField(fieldTemplate))
        });
    }
}
_define_property(TemplatedFields, "propTypes", {
    template: PropTypes.arrayOf(templateFieldShape).isRequired,
    disabledFields: PropTypes.array,
    formValues: PropTypes.object,
    messages: PropTypes.object,
    localizationResources: PropTypes.object,
    validatorRules: PropTypes.object,
    isOneLiner: PropTypes.bool,
    onAddValidatorRules: PropTypes.func,
    onSetFormValue: PropTypes.func,
    onSetFormValues: PropTypes.func
});
_define_property(TemplatedFields, "defaultProps", {
    disabledFields: [],
    isOneLiner: false
});
export default TemplatedFields;
